import { render, staticRenderFns } from "./AdminListAdmin.vue?vue&type=template&id=7cb70dfa&"
import script from "./AdminListAdmin.vue?vue&type=script&lang=ts&"
export * from "./AdminListAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports